import { Injectable } from '@angular/core';

/**
 * Light/dark theme, applied as a class on `<html>` (Tailwind `darkMode: 'class'`).
 * Starts from the device preference and is not persisted, as the old floating
 * switcher did; the toggle lives in the navbar.
 */
@Injectable({ providedIn: 'root' })
export class ThemeService {
   private readonly html = document.documentElement;

   constructor() {
      const prefersDark = typeof window !== 'undefined' && !!window.matchMedia?.('(prefers-color-scheme: dark)').matches;
      this.set(prefersDark);
   }

   get isDark(): boolean {
      return this.html.classList.contains('dark');
   }

   toggle(): void {
      this.set(!this.isDark);
   }

   set(dark: boolean): void {
      this.html.classList.toggle('dark', dark);
      this.html.classList.toggle('light', !dark);
   }
}
